import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Card, CardBody, Form, Label, Button } from "reactstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import debounce from "lodash.debounce";

import {
  getBranches,
  getStudyLevels,
} from "store/actions";

const SearchSessionResult = ({ onSearch }) => {
  const dispatch = useDispatch();

  const [selectedBranch,     setSelectedBranch]     = useState(null);
  const [selectedStudyLevel, setSelectedStudyLevel] = useState(null);

  const { branches, studyLevels } = useSelector((state) => ({
    branches:    state.branchReducer.branches        || [],
    studyLevels: state.studyLevelReducer.studyLevels || [],
  }));

  useEffect(() => {
    dispatch(getBranches());
    dispatch(getStudyLevels());
  }, [dispatch]);

  // --- Options filtrées ---

  const branchOptions = branches.map((b) => ({
    value: b.id,
    label: b.name,
  }));

  const studyLevelOptions = selectedBranch
    ? studyLevels
        .filter((l) => l.branch_id === selectedBranch.value)
        .map((l) => ({ value: l.id, label: l.name }))
    : [];

  // --- Récupérer les filtres actuels ---
  const getCurrentPayload = () => ({
    branch_id:         selectedBranch?.value      || "",
    study_level_id:    selectedStudyLevel?.value  || "",
    study_level_label: selectedStudyLevel?.label  || "",
  });


  // --- Handlers avec reset en cascade ---

  const handleBranchChange = (selected) => {
    setSelectedBranch(selected);
    setSelectedStudyLevel(null);
  };

  const handleStudyLevelChange = (selected) => {
    setSelectedStudyLevel(selected);
  };

  // --- Debounce search ---
  const debouncedSearchRef = useRef(
    debounce((payload) => {
      // On lance la recherche automatiquement si au moins le niveau est sélectionné
      if (payload.study_level_id) {
        onSearch(payload);
      }
    }, 500)
  );

  useEffect(() => {
    const payload = getCurrentPayload();
    if (payload.study_level_id) {
        debouncedSearchRef.current(payload);
    }
  }, [selectedBranch, selectedStudyLevel]);

  // --- Reset complet ---
  const handleReset = () => {
    setSelectedBranch(null);
    setSelectedStudyLevel(null);
  };

  // --- Bouton Rechercher ---
  const handleSearch = () => {
    debouncedSearchRef.current.cancel(); 
    onSearch(getCurrentPayload());       
  };

  return (
    <Row>
      <Col lg={12}>
        <Card className="session-result-filter">
          <CardBody>
            <Form>
              <Row className="g-3">

                {/* Filière */}
                <Col xxl={4} lg={4}>
                  <Label>Filière</Label>
                  <Select
                    options={branchOptions}
                    value={selectedBranch}
                    onChange={handleBranchChange}
                    isClearable
                    placeholder="Sélectionner une filière"
                  />
                </Col>

                {/* Niveau */}
                <Col xxl={4} lg={4}>
                  <Label className={!selectedBranch ? "text-muted" : ""}>
                    Niveau (classe)
                  </Label>
                  <Select
                    options={studyLevelOptions}
                    value={selectedStudyLevel}
                    onChange={handleStudyLevelChange}
                    isClearable
                    isDisabled={!selectedBranch}
                    placeholder={
                      selectedBranch
                        ? "Sélectionner un niveau"
                        : "Choisir une filière d'abord"
                    }
                  />
                </Col>

              </Row>

              <Row className="g-3 mt-3">
                <Col xxl={3} lg={4} className="d-flex gap-2">
                  <Button
                    color="primary"
                    type="button"
                    onClick={handleSearch}
                    disabled={!selectedStudyLevel} // Bloque si pas de niveau sélectionné
                  >
                    Rechercher
                  </Button>
                  <Button
                    color="secondary"
                    outline
                    type="button"
                    onClick={handleReset}
                  >
                    Réinitialiser
                  </Button>
                </Col>
              </Row>

            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default SearchSessionResult;